export default (function () {
  return $('.header').height() + $('.sub-header').height();
});